import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,
  modules: {
    namespaced: true,
  },
  state: {
    appbar: '',
    dialogs: {
      verification: false,
    },
  },
  actions: {
    APPBAR_STYLE: (ctx, style) => {
      ctx.commit('SET_APPBAR_STYLE', style)
    },
    APPBAR_TRANSPARENTABLE: ctx => {
      ctx.commit('SET_APPBAR_STYLE', 'transparent-bg')
    },
    APPBAR_NON_TRANSPARENTABLE: ctx => {
      ctx.commit('SET_APPBAR_STYLE', '')
    },
  },
  mutations: {
    SET_APPBAR_STYLE: (state, style) => {
      state.appbar = style
    },
    setDialog: (state, { name, value }) => {
      state.dialogs[name] = value
    },
  },
  getters: {
    getDialogValue: state => name => state.dialogs[name],
  },
})

export default store
